import { makeError } from '../utils/error';
import { v4 as uuid } from 'uuid';
import { Payment } from './Schedule';
import { Specialty, UnitHealthPlans } from './Specialist';
import { CREATE_SCHEDULE_APPOINTMENTS_TYPES } from '../utils/enums/appointment-types';

export type ScheduleSpecialist = {
  id: string;
  date?: string;
  hour?: string;
  specialityList: Specialty[]; //
  attendanceType?: string;
  interval?: number;
  return_time?: string;
  idPatient?: string; //
  image?: string;
  payment?: Payment;
  originId?: number;
  appointmentType?: string;
  resource: {
    name: string;
    specialty?: string;
    medicalProcedureId: string | number;
    professionalId: string;
    companyId: number;
    specialistId: string;
    professionalCode: string;
  };
  unit: {
    name: string;
    catalogId: string;
    address: string;
    officeId: string;
  };
  catalog: {
    name: string;
    itemId?: string;
    productId?: string;
    serviceId?: string;
  };
};

export const ScheduleSpecialistBuilder = (specialistSchedule?: ScheduleSpecialist) => {
  const schedule = specialistSchedule || ({} as ScheduleSpecialist);

  const checkPropertyError = () => {
    if (!schedule.resource.companyId) makeError('Missing schedule.resource.companyId property');
    if (!schedule.resource.professionalId) makeError('Missing schedule.resource.professionalId property');
    if (!schedule.date) makeError('Missing schedule.date property');
    if (!schedule.hour) makeError('Missing schedule.hour property');
    if (!schedule.resource.medicalProcedureId) makeError('Missing schedule.medicalProcedureId property');
    if (!schedule.resource.name) makeError('Missing schedule.resource.name property');
    if (!schedule.resource.specialty) makeError('Missing schedule.resource.specialty property');
    if (!schedule.attendanceType) makeError('Missing schedule.attendanceType property');
    if (!schedule.interval) makeError('Missing schedule.interval property');
    if (!schedule.idPatient) makeError('Missing schedule.idPatient property');
    if (!schedule.payment) makeError('Missing schedule.payment property');
    if (!schedule.appointmentType) makeError('Missing schedule.appointmentType property');
  };

  function setSpecialist(props: { specialityList: Specialty[]; image: string; interval: number }) {
    schedule.specialityList = props.specialityList;
    schedule.image = props.image;
    schedule.interval = props.interval;
    schedule.id = uuid();
    return schedule;
  }

  function setAppointmentType(type: string) {
    schedule.appointmentType = type;
    return schedule;
  }

  function setPatient(patientId: string) {
    schedule.idPatient = patientId;
    return schedule;
  }

  function setPayment(payment: Payment) {
    schedule.payment = payment;
    return schedule;
  }

  function setResource(props: {
    medicalProcedureId: number;
    companyId: number;
    professionalId: string;
    resourceName: string;
    specialty?: string;
    specialistId: string;
    crm: string;
  }) {
    const resource = {
      name: props.resourceName,
      specialty: props.specialty,
      professionalId: props.professionalId,
      medicalProcedureId: props.medicalProcedureId,
      companyId: props.companyId,
      specialistId: props.specialistId,
      professionalCode: props.crm
    };
    schedule.resource = resource;
    return schedule;
  }

  function setUnit(props: {
    attendanceType: string;
    office_id: string;
    unitName: string;
    // unitHealthPlans: UnitHealthPlans | undefined;
    price?: string | undefined;
    catalogUnitId: string;
    unitAddress: string;
    // return_time?: string;
  }) {
    const unit = {
      name: props.unitName,
      catalogId: props.catalogUnitId,
      address: props.unitAddress,
      officeId: props.office_id
    };
    schedule.unit = unit;
    // schedule.return_time = props.return_time;

    schedule.catalog = { name: 'Consulta médica' };

    if (schedule.appointmentType === CREATE_SCHEDULE_APPOINTMENTS_TYPES.FIRST_APPOINTMENT)
      schedule.catalog = { name: 'Primeira consulta' };
    if (schedule.appointmentType === CREATE_SCHEDULE_APPOINTMENTS_TYPES.RETURN)
      schedule.catalog = { name: 'Consulta de retorno' };

    schedule.attendanceType = props.attendanceType;
    // schedule.unitHealthPlans = props.unitHealthPlans;
    if (props.price)
      schedule.payment = {
        ...schedule.payment,
        price: props.price
      };

    return schedule;
  }

  function setAppointmentDetails(props: { unitHealthPlans: UnitHealthPlans | undefined; return_time?: string }) {
    schedule.return_time = props.return_time;

    // schedule.unitHealthPlans = props.unitHealthPlans;

    return schedule;
  }

  function setDateHour(props: { date: string; hour: string }) {
    schedule.date = props.date;
    schedule.hour = props.hour;
    return schedule;
  }

  function validateSchedule() {
    checkPropertyError();
    return schedule;
  }

  function build() {
    return schedule;
  }

  return {
    setSpecialist,
    setPatient,
    setUnit,
    setResource,
    setDateHour,
    validateSchedule,
    setPayment,
    setAppointmentType,
    schedule,
    setAppointmentDetails,
    build
  };
};
